module.exports = __webpack_public_path__ + "aa324e8ba1d2de80b75779e484a4d73e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-zig-mint.png
// module id = 1384
// module chunks = 0